import request from '../util/axios/axios';

export function addorder(form) {
    return request({
        url: '/star/ext/api/v1/order',
        method: 'POST',
        data: form,
        headers: {
            'Content-type': 'application/json',
            'Accept-Language': 'ko',
            'consumerKey': 'RwAAAAAAADqZAAAAAFdYDFta',
            'accessToken': 'RwAAAAAAADqZAAAAAAAAAAAAAAAAAAAAj0CKuA=='
        }
    })
}

export function getPrice(form) {
    return request({
        url: '/star/ext/api/v1/price',
        method: 'POST',
        data: form,
        headers: {
            'Content-type': 'application/json',
            'Accept-Language': 'ko',
            'consumerKey': 'RwAAAAAAADqZAAAAAFdYDFta',
            'accessToken': 'RwAAAAAAADqZAAAAAAAAAAAAAAAAAAAAj0CKuA=='
        }
    })
}

export function getorder(orderNo) {
    return request({
        url: `/star/ext/api/v1/order/${orderNo}`,
        method: 'get',
        headers: {
            'Content-type': 'application/json',
            'Accept-Language': 'ko',
            'consumerKey': 'RwAAAAAAADqZAAAAAFdYDFta',
            'accessToken': 'RwAAAAAAADqZAAAAAAAAAAAAAAAAAAAAj0CKuA=='
        }
    })
}

export function orderDel(form) {
    return request({
        url: '/star/ext/api/v1/order',
        method: 'DELETE',
        data: form,
        headers: {
            'Content-type': 'application/json',
            'Accept-Language': 'ko',
            'consumerKey': 'RwAAAAAAADqZAAAAAFdYDFta',
            'accessToken': 'RwAAAAAAADqZAAAAAAAAAAAAAAAAAAAAj0CKuA=='
        }
    })
}

export function cardInsert(form) {
    return request({
        url: '/star/ext/api/v1/order/bill',
        method: 'POST',
        data: form,
        headers: {
            'Content-type': 'application/json',
            'Accept-Language': 'ko',
            'consumerKey': 'RwAAAAAAADqZAAAAAFdYDFta',
            'accessToken': 'RwAAAAAAADqZAAAAAAAAAAAAAAAAAAAAj0CKuA=='
        }
    })
}

export function cardInfo(orderNo) {
    return request({
        url: `/star/ext/api/v1/order/${orderNo}/bill`,
        method: 'GET',
        headers: {
            'Content-type': 'application/json',
            'Accept-Language': 'ko',
            'consumerKey': 'RwAAAAAAADqZAAAAAFdYDFta',
            'accessToken': 'RwAAAAAAADqZAAAAAAAAAAAAAAAAAAAAj0CKuA=='
        }
    })
}